export function supportsWebp (callback) {
  if (
    typeof window === 'undefined' ||
    typeof document === 'undefined'
  ) return false

  if (!callback) return false

  let r = false
  const webpData = 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA'
  var img = new window.Image()
  img.onload = function () {
    var result = (img.width > 0) && (img.height > 0)
    callback(result)
  }
  img.onerror = function () { return false }
  img.src = 'data:image/webp;base64,' + webpData
  return r
}



// WEBPACK FOOTER //
// ./src/helpers/webp.js